import { render, staticRenderFns } from "./AddGuidanceWorkplacePage.vue?vue&type=template&id=ec7374e4&"
import script from "./AddGuidanceWorkplacePage.vue?vue&type=script&lang=js&"
export * from "./AddGuidanceWorkplacePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports